import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { normalize } from "normalizr";
import { referrersSchema, customFieldsSchema } from "./referrer-schema";
import { get, getSelectReferrers, getReferrerCustomFields, getReferrerLinkedApps, getReferrerLinkedProfiles, create, createReferrerCustomFieldDefinition, update, updateReferrerCustomFieldDeclaration, updateReferrerCustomFieldOrder, remove, removeReferrerCustomFieldDefinition, createReferrerChecklist, deleteReferrerChecklist, saveReferrerChecklist, createReferrerFollowUp, deleteReferrerFollowUp, updateReferrerFollowUp, toggleReferrerPin, addReferrerNote, deleteReferrerNote, updateReferrerNote, getReferrerTimeline, getReferrerChangelog } from "../api/referrer-api";
import { SET_REFERRERS, SET_REFERRER, SET_REFERRERS_CUSTOM_FIELDS_DEFINITIONS, SET_REFERRER_CUSTOM_FIELDS, SET_REFERRER_CUSTOM_FIELD_DEFINITION, SET_REFERRER_CUSTOM_FIELD_ORDER, SET_REFERRER_LINKED_APPS, SET_REFERRER_LINKED_PROFILES, EDIT_REFERRER, REMOVE_REFERRER, REMOVE_REFERRER_CUSTOM_FIELD_DEFINITION, ADD_REFERRER_CUSTOM_FIELD_DEFINITION, ADD_REFERRER_TIMELINE_ITEM, SET_REFERRER_TIMELINE_ITEM_DETAILS, REMOVE_REFERRER_TIMELINE_ITEM, SET_REFERRER_TIMELINE, SET_REFERRER_CHANGELOG, SET_CURRENT_FILTERS } from "./referrer-mutations";
import Err from "@Broker/@Routes/error";
import Amplitude from "@Shared/@Utils/amplitude";
import { getOrphanCustomFields, mergeCustomFields, replaceSubstitutionsTags } from "@Broker/js/utils/store-helpers/client-profile";
import { getArrayNextItem, getFormattedScheduledTime } from "@Shared/@Utils/utils";
import { VALID_TIMELINE_ITEMS } from "@Broker/js/custom/utils";
import { cloneDeep, isEmpty, map, sortBy, values } from "lodash";
import moment from "moment";
import Vue from "vue";
export const LOAD_REFERRERS = "LOAD_REFERRERS";
export const LOAD_REFERRER = "LOAD_REFERRER";
export const LOAD_REFERRER_CUSTOM_FIELDS = "LOAD_REFERRER_CUSTOM_FIELDS";
export const CREATE_REFERRER = "CREATE_REFERRER";
export const CREATE_REFERRER_CUSTOM_FIELD_DEFINITION = "CREATE_REFERRER_CUSTOM_FIELD_DEFINITION";
export const UPDATE_REFERRER = "UPDATE_REFERRER";
export const UPDATE_REFERRER_CUSTOM_FIELDS_DATA = "UPDATE_REFERRER_CUSTOM_FIELDS_DATA";
export const DELETE_REFERRER = "DELETE_REFERRER";
export const DELETE_REFERRER_CUSTOM_FIELD_DEFINITION = "DELETE_REFERRER_CUSTOM_FIELD_DEFINITION";
export const MERGE_REFERRER_CUSTOM_FIELDS = "MERGE_REFERRER_CUSTOM_FIELDS";
export const TOGGLE_REFERRER_CUSTOM_FIELD_DEFINITION_VISIBILITY = "TOGGLE_REFERRER_CUSTOM_FIELD_DEFINITION_VISIBILITY";
export const ORDER_REFERRER_CUSTOM_FIELD_DEFINITION = "ORDER_REFERRER_CUSTOM_FIELD_DEFINITION";
export const UPDATE_REFERRER_CUSTOM_FIELD_DEFINITION = "UPDATE_REFERRER_CUSTOM_FIELD_DEFINITION";
export const LOAD_REFERRER_LINKED_APPS = "LOAD_REFERRER_LINKED_APPS";
export const LOAD_REFERRER_LINKED_PROFILES = "LOAD_REFERRER_LINKED_PROFILES";
export const PIN_REFERRER_TIMELINE_ITEM = "PIN_REFERRER_TIMELINE_ITEM";
export const ADD_REFERRER_FOLLOW_UP = "ADD_REFERRER_FOLLOW_UP";
export const DELETE_REFERRER_FOLLOW_UP = "DELETE_REFERRER_FOLLOW_UP";
export const EDIT_REFERRER_FOLLOW_UP = "EDIT_REFERRER_FOLLOW_UP";
export const ADD_REFERRER_NOTE = "ADD_REFERRER_NOTE";
export const DELETE_REFERRER_NOTE = "DELETE_REFERRER_NOTE";
export const EDIT_REFERRER_NOTE = "EDIT_REFERRER_NOTE";
export const ADD_REFERRER_CHECKLIST = "ADD_REFERRER_CHECKLIST";
export const DELETE_REFERRER_CHECKLIST = "DELETE_REFERRER_CHECKLIST";
export const EDIT_REFERRER_CHECKLIST = "EDIT_REFERRER_CHECKLIST";
export const LOAD_REFERRER_TIMELINE = "LOAD_REFERRER_TIMELINE";
export const LOAD_REFERRER_CHANGELOG = "LOAD_REFERRER_CHANGELOG";
const actions = {
  [LOAD_REFERRERS]: async (context, {
    offset = 0,
    limit = 20,
    orderBy,
    orderType,
    searchString,
    type,
    concatenate = false
  } = {}) => {
    try {
      context.commit(SET_CURRENT_FILTERS, {
        orderBy,
        orderType,
        searchString,
        type
      });
      const params = _objectSpread({
        offset,
        limit
      }, context.state.referrerFilters);
      const {
        referrers,
        referrerCount: total
      } = await getSelectReferrers(params);
      const {
        entities,
        result
      } = normalize(referrers, [referrersSchema]);
      context.commit(SET_REFERRERS, {
        referrers: {
          byId: (entities == null ? void 0 : entities.referrers) || {},
          allIds: result
        },
        total,
        add: concatenate ? true : offset != null ? offset : 0,
        rawReferrers: referrers
      });
    } catch (e) {
      Err.handle(e, {}, "failedToLoadReferrers");
    }
  },
  [LOAD_REFERRER]: async (context, {
    referrerId
  }) => {
    try {
      const referrer = await get(referrerId);
      context.commit(SET_REFERRER, {
        referrerId: referrer.id,
        referrer
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [CREATE_REFERRER]: async (context, {
    referrer
  }) => {
    try {
      const {
        referrerId
      } = await create(referrer);
      Amplitude.updateCount("REFERRER_CREATED");
      Amplitude.logEvent("Referrers - created");
      context.commit(SET_REFERRER, {
        referrerId,
        referrer
      });
      return {
        referrerId
      };
    } catch (e) {
      Err.handle(e, {
        referrer
      }, "failedToCreateReferrerParticipant");
      throw e;
    }
  },
  [UPDATE_REFERRER]: async (context, {
    referrerId,
    referrer
  }) => {
    const oldDetails = context.state.referrers.byId[referrerId];
    const newReferrer = _objectSpread(_objectSpread({}, referrer), {}, {
      customFields: oldDetails.customFields,
      updatedAt: moment().format()
    });
    try {
      context.commit(EDIT_REFERRER, {
        referrerId,
        referrer: newReferrer
      });
      await update(referrerId, newReferrer);
    } catch (e) {
      context.commit(EDIT_REFERRER, {
        referrerId,
        referrer: oldDetails
      });
      Err.handle(e);
      throw e;
    }
  },
  [DELETE_REFERRER]: async (context, {
    referrerId
  }) => {
    const oldDetails = context.state.referrers.byId[referrerId];
    try {
      context.commit(REMOVE_REFERRER, {
        referrerId
      });
      await remove(referrerId);
    } catch (e) {
      context.commit(SET_REFERRER, {
        referrerId,
        referrer: oldDetails
      });
      Err.handle(e);
      throw e;
    }
  },
  [LOAD_REFERRER_CUSTOM_FIELDS]: async context => {
    try {
      const {
        customReferrerFields
      } = await getReferrerCustomFields();
      if (isEmpty(customReferrerFields)) return;
      const {
        entities,
        result
      } = normalize(customReferrerFields, [customFieldsSchema]);
      const referrersCustomFieldsDefinitions = {
        byId: entities.customFields,
        allIds: result
      };
      referrersCustomFieldsDefinitions.allIds = sortBy(referrersCustomFieldsDefinitions.allIds, id => {
        var _referrersCustomField, _referrersCustomField2;
        const {
          name,
          classification
        } = (_referrersCustomField = (_referrersCustomField2 = referrersCustomFieldsDefinitions.byId) == null ? void 0 : _referrersCustomField2[id]) != null ? _referrersCustomField : {};
        const weightMap = {
          "Upcoming Date": 1,
          "Closing Date": 2,
          "Renewal Date": 3,
          Label: 4
        };
        return classification === "system" && weightMap[name] || Infinity;
      });
      context.commit(SET_REFERRERS_CUSTOM_FIELDS_DEFINITIONS, {
        referrersCustomFieldsDefinitions
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [MERGE_REFERRER_CUSTOM_FIELDS]: async (context, {
    referrerId
  }) => {
    try {
      var _context$state$referr;
      const currentCustomFields = cloneDeep((_context$state$referr = context.state.referrers.byId[referrerId]) == null ? void 0 : _context$state$referr.customFields);
      const customFieldsDefinitions = context.state.referrersCustomFieldsDefinitions;
      if (isEmpty(customFieldsDefinitions || currentCustomFields)) return;
      if (!currentCustomFields) return;
      const orphanCustomFields = getOrphanCustomFields(currentCustomFields, customFieldsDefinitions);
      const mergedCustomFields = mergeCustomFields(currentCustomFields, customFieldsDefinitions);
      context.commit(SET_REFERRER_CUSTOM_FIELDS, {
        referrerId,
        customFields: [...mergedCustomFields, ...orphanCustomFields]
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [CREATE_REFERRER_CUSTOM_FIELD_DEFINITION]: async (context, {
    customFieldDefinition
  }) => {
    try {
      const {
        customFieldId,
        fieldOrder
      } = await createReferrerCustomFieldDefinition(customFieldDefinition);
      context.commit(ADD_REFERRER_CUSTOM_FIELD_DEFINITION, {
        customFieldDefinition: _objectSpread(_objectSpread({}, customFieldDefinition), {}, {
          classification: "user",
          id: customFieldId,
          fieldOrder
        })
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [UPDATE_REFERRER_CUSTOM_FIELDS_DATA]: async (context, {
    referrerId,
    customFields
  }) => {
    context.commit(SET_REFERRER_CUSTOM_FIELDS, {
      referrerId,
      customFields
    });
  },
  [DELETE_REFERRER_CUSTOM_FIELD_DEFINITION]: async (context, {
    customFieldDefinitionId
  }) => {
    try {
      await removeReferrerCustomFieldDefinition(customFieldDefinitionId);
      context.commit(REMOVE_REFERRER_CUSTOM_FIELD_DEFINITION, {
        customFieldDefinitionId
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [TOGGLE_REFERRER_CUSTOM_FIELD_DEFINITION_VISIBILITY]: async (context, {
    customFieldDefinitionId
  }) => {
    const customFieldDefinition = context.state.referrersCustomFieldsDefinitions.byId[customFieldDefinitionId];
    const oldVisibility = customFieldDefinition.visibility;
    try {
      const newVisibility = getArrayNextItem(oldVisibility, ["none", "full", "compact"]);
      context.commit(SET_REFERRER_CUSTOM_FIELD_DEFINITION, {
        customFieldDefinition: _objectSpread(_objectSpread({}, customFieldDefinition), {}, {
          visibility: newVisibility
        })
      });
      await updateReferrerCustomFieldDeclaration(_objectSpread(_objectSpread({}, customFieldDefinition), {}, {
        visibility: newVisibility
      }));
    } catch (e) {
      context.commit(SET_REFERRER_CUSTOM_FIELD_DEFINITION, {
        customFieldDefinition: _objectSpread(_objectSpread({}, customFieldDefinition), {}, {
          visibility: oldVisibility
        })
      });
      Err.handle(e);
    }
  },
  [ORDER_REFERRER_CUSTOM_FIELD_DEFINITION]: async (context, {
    customFieldDefinitions
  }) => {
    const oldCustomFieldsDefinitions = cloneDeep(values(context.state.referrersCustomFieldsDefinitions.byId));
    try {
      const updatedCustomFieldDefinitions = map(customFieldDefinitions, ({
        id
      }, index) => ({
        id,
        fieldOrder: index + 1
      }));
      context.commit(SET_REFERRER_CUSTOM_FIELD_ORDER, {
        customFieldDefinitions: updatedCustomFieldDefinitions
      });
      await updateReferrerCustomFieldOrder(updatedCustomFieldDefinitions);
    } catch (e) {
      context.commit(SET_REFERRER_CUSTOM_FIELD_ORDER, {
        customFieldDefinitions: oldCustomFieldsDefinitions
      });
      Err.handle(e);
    }
  },
  [UPDATE_REFERRER_CUSTOM_FIELD_DEFINITION]: async (context, {
    customFieldDefinition
  }) => {
    try {
      await updateReferrerCustomFieldDeclaration(customFieldDefinition);
      context.commit(SET_REFERRER_CUSTOM_FIELD_DEFINITION, {
        customFieldDefinition
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [LOAD_REFERRER_LINKED_APPS]: async (context, {
    referrerId
  }) => {
    try {
      const {
        clientApplications
      } = await getReferrerLinkedApps(referrerId);
      context.commit(SET_REFERRER_LINKED_APPS, {
        referrerId,
        clientApplications
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_REFERRER_LINKED_PROFILES]: async (context, {
    referrerId
  }) => {
    try {
      const {
        clientProfiles,
        translationMap
      } = await getReferrerLinkedProfiles(referrerId);
      context.commit(SET_REFERRER_LINKED_PROFILES, {
        referrerId,
        clientProfiles,
        translationMap
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [ADD_REFERRER_CHECKLIST]: async (context, {
    id,
    checklist,
    title
  }) => {
    const {
      checklistId
    } = await createReferrerChecklist(id, checklist, title);
    const date = moment().utc().format();
    context.commit(ADD_REFERRER_TIMELINE_ITEM, {
      referrerId: id,
      newItem: {
        activityType: "checklist",
        checklist,
        title,
        creator: Vue.auth.session.get().userDetails,
        id: checklistId,
        pinned: false,
        updatedAt: date,
        createdAt: date
      }
    });
    Amplitude.logEvent("Referrer - checklist created", {
      page: "referrer-detail",
      referrerId: id
    });
  },
  [DELETE_REFERRER_CHECKLIST]: async (context, {
    referrerId,
    checklistId
  }) => {
    await deleteReferrerChecklist(referrerId, checklistId);
    context.commit(REMOVE_REFERRER_TIMELINE_ITEM, {
      referrerId,
      timelineItemType: "checklist",
      timelineItemId: checklistId
    });
  },
  [EDIT_REFERRER_CHECKLIST]: async (context, {
    referrerId,
    checklistId,
    data,
    title
  }) => {
    await saveReferrerChecklist(referrerId, checklistId, data, title);
    context.commit(SET_REFERRER_TIMELINE_ITEM_DETAILS, {
      referrerId,
      timelineItemType: "checklist",
      timelineItemId: checklistId,
      checklist: data,
      title
    });
    Amplitude.logEvent("Referrer - checklist updated", {
      page: "referrer",
      checklistId: data.id,
      referrerId
    });
  },
  [ADD_REFERRER_FOLLOW_UP]: async (context, {
    id,
    followUp: followUpData
  }) => {
    const {
      followUpId
    } = await createReferrerFollowUp(id, followUpData);
    const date = moment().utc().format();
    const detailsForSubstitution = context.getters.getDetailsForSubstitution(id);
    context.commit(ADD_REFERRER_TIMELINE_ITEM, {
      referrerId: id,
      newItem: {
        activityType: "follow-up",
        complete: false,
        createdAt: date,
        updatedAt: date,
        creator: Vue.auth.session.get().userDetails,
        description: replaceSubstitutionsTags(followUpData.description, detailsForSubstitution),
        id: followUpId,
        pinned: false,
        scheduledDate: followUpData.scheduledDate,
        scheduledTime: getFormattedScheduledTime(followUpData.scheduledTime),
        assignees: followUpData.assignees
      }
    });
  },
  [DELETE_REFERRER_FOLLOW_UP]: async (context, {
    referrerId,
    followUpId
  }) => {
    await deleteReferrerFollowUp(referrerId, followUpId);
    context.commit(REMOVE_REFERRER_TIMELINE_ITEM, {
      referrerId,
      timelineItemType: "follow-up",
      timelineItemId: followUpId
    });
  },
  [EDIT_REFERRER_FOLLOW_UP]: async (context, {
    referrerId,
    followUpId,
    data
  }) => {
    const detailsForSubstitution = context.getters.getDetailsForSubstitution(referrerId);
    await updateReferrerFollowUp(referrerId, followUpId, data);
    context.commit(SET_REFERRER_TIMELINE_ITEM_DETAILS, _objectSpread(_objectSpread({
      referrerId,
      timelineItemType: "follow-up",
      timelineItemId: followUpId
    }, data), {}, {
      description: replaceSubstitutionsTags(data.description, detailsForSubstitution)
    }));
  },
  [ADD_REFERRER_NOTE]: async (context, {
    id,
    note
  }) => {
    const {
      noteId
    } = await addReferrerNote(id, note);
    const date = moment().utc().format();
    const detailsForSubstitution = context.getters.getDetailsForSubstitution(id);
    context.commit(ADD_REFERRER_TIMELINE_ITEM, {
      referrerId: id,
      newItem: {
        activityType: "note",
        creator: Vue.auth.session.get().userDetails,
        id: noteId,
        note: replaceSubstitutionsTags(note, detailsForSubstitution),
        notified: false,
        pinned: false,
        updatedAt: date,
        createdAt: date
      }
    });
    return noteId;
  },
  [DELETE_REFERRER_NOTE]: async (context, {
    referrerId,
    noteId
  }) => {
    await deleteReferrerNote(referrerId, noteId);
    context.commit(REMOVE_REFERRER_TIMELINE_ITEM, {
      referrerId,
      timelineItemType: "note",
      timelineItemId: noteId
    });
  },
  [EDIT_REFERRER_NOTE]: async (context, {
    referrerId,
    noteId,
    data
  }) => {
    const detailsForSubstitution = context.getters.getDetailsForSubstitution(referrerId);
    await updateReferrerNote(referrerId, noteId, data);
    context.commit(SET_REFERRER_TIMELINE_ITEM_DETAILS, {
      referrerId,
      timelineItemType: "note",
      timelineItemId: noteId,
      note: replaceSubstitutionsTags(data.note, detailsForSubstitution)
    });
  },
  [LOAD_REFERRER_TIMELINE]: async (context, {
    referrerId
  }) => {
    try {
      let {
        timeline
      } = await getReferrerTimeline(referrerId);
      timeline = _filterInstanceProperty(timeline).call(timeline, ({
        activityType
      }) => activityType && _includesInstanceProperty(VALID_TIMELINE_ITEMS).call(VALID_TIMELINE_ITEMS, activityType));
      context.commit(SET_REFERRER_TIMELINE, {
        timeline,
        referrerId
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_REFERRER_CHANGELOG]: async (context, {
    referrerId
  }) => {
    try {
      const {
        changelog
      } = await getReferrerChangelog(referrerId);
      context.commit(SET_REFERRER_CHANGELOG, {
        changelog,
        referrerId
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [PIN_REFERRER_TIMELINE_ITEM]: async (context, {
    referrerId,
    id,
    pinned,
    type
  }) => {
    await toggleReferrerPin(referrerId, type, id);
    context.commit(SET_REFERRER_TIMELINE_ITEM_DETAILS, {
      referrerId,
      timelineItemType: type,
      timelineItemId: id,
      pinned
    });
  }
};
export default actions;